import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // index子路由的重定向
  {
    path: '',
    redirect: '/index',
  },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  { // 首页  *********************************************
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue')
  },


  { // 关于卓信  *********************************************
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  },
  { // 关于卓信 ----  公司简介
    path: '/about/profile',
    name: 'profile',
    component: () => import('../views/about/profile.vue'),
  },
  { // 关于卓信 ----  市场布局
    path: '/about/layout',
    name: 'layout',
    component: () => import('../views/about/layout.vue'),
  },
  { // 关于卓信 ----  产品研发
    path: '/about/developm',
    name: 'developm',
    component: () => import('../views/about/developm.vue'),
  },
  { // 关于卓信 ----  知识产权
    path: '/about/ownership',
    name: 'ownership',
    component: () => import('../views/about/ownership.vue'),
  },
  { // 关于卓信 ----  品控
    path: '/about/qualityCon',
    name: 'qualityCon',
    component: () => import('../views/about/qualityCon.vue'),
  },
  { // 关于卓信 ----  资质和荣誉
    path: '/about/qualifica',
    name: 'qualifica',
    component: () => import('../views/about/qualifica.vue'),
  },
  { // 关于卓信 ----  任职和参建
    path: '/about/appoint',
    name: 'appoint',
    component: () => import('../views/about/appoint.vue'),
  },


  { // 核心业务  *********************************************
    path: '/business',
    name: 'business',
    component: () => import('../views/business.vue')
  },
  { // 核心业务 ----  通信工程
    path: '/business/commun',
    name: 'commun',
    component: () => import('../views/business/commun.vue'),
  },
  { // 核心业务 ----  DICT
    path: '/business/DICT',
    name: 'DICT',
    component: () => import('../views/business/dict.vue'),
  },
  { // 核心业务 ----  智慧光纤分配管理系统
    path: '/business/opticalfib',
    name: 'opticalfib',
    component: () => import('../views/business/opticalfib.vue'),
  },
  { // 核心业务 ----  无线通信产品
    path: '/business/wireless',
    name: 'wireless',
    component: () => import('../views/business/wireless.vue'),
  },


  { // 核心业务 ----  城市物联网
    path: '/business/Internetthing',
    name: 'Internetthing',
    component: () => import('../views/business/Internetthing.vue'),
  },
  { // 核心业务 ----  城市物联网 --------- 软件产品
    path: '/business/Internetthing/software',
    name: 'software',
    component: () => import('../views/business/Internetthing/software.vue'),
  },
  { // 核心业务 ----  城市物联网 --------- 智慧多功能杆                                         
    path: '/business/Internetthing/funRod',
    name: 'int_funRod',
    component: () => import('../views/business/Internetthing/funRod.vue'),
  },
  { // 核心业务 ----  城市物联网 --------- 核心硬件
    path: '/business/Internetthing/hardware',
    name: 'hardware',
    component: () => import('../views/business/Internetthing/hardware.vue'),
  },
  { // 核心业务 ----  城市物联网 --------- 应用场景
    path: '/business/Internetthing/scene',
    name: 'scene',
    component: () => import('../views/business/Internetthing/scene.vue'),
  },


  { // 服务案例   *********************************************
    path: '/employ',
    name: 'employ',
    component: () => import('../views/employ.vue'),
  },
  { // 服务案例 ----  智慧园区/社区
    path: '/employ/park',
    name: 'park',
    component: () => import('../views/employ/park.vue'),
  },
  { // 服务案例 ----  智慧医疗
    path: '/employ/treat',
    name: 'treat',
    component: () => import('../views/employ/treat.vue'),
  },
  { // 服务案例 ----  智慧校园
    path: '/employ/campus',
    name: 'campus',
    component: () => import('../views/employ/campus.vue'),
  },
  { // 服务案例 ----  智慧消防
    path: '/employ/firefig',
    name: 'firefig',
    component: () => import('../views/employ/firefig.vue'),
  },
  { // 服务案例 ----  智慧水务
    path: '/employ/wateraff',
    name: 'wateraff',
    component: () => import('../views/employ/waterAff.vue'),
  },
  { // 服务案例 ----  市政工程
    path: '/employ/engineer',
    name: 'engineer',
    component: () => import('../views/employ/engineer.vue'),
  },
  { // 服务案例 ----  室内分布
    path: '/employ/distribu',
    name: 'distribu',
    component: () => import('../views/employ/distribu.vue'),
  },
  { // 服务案例 ----  宽带接入
    path: '/employ/broadband',
    name: 'broadband',
    component: () => import('../views/employ/broadband.vue'),
  },
  { // 服务案例 ----  传输预覆盖
    path: '/employ/cover',
    name: 'cover',
    component: () => import('../views/employ/cover.vue'),
  },
  { // 服务案例 ----  智慧多功能杆
    path: '/employ/funRod',
    name: 'funRod',
    component: () => import('../views/employ/funRod.vue'),
  },
  { // 服务案例 ----  其他案例
    path: '/employ/other',
    name: 'other',
    component: () => import('../views/employ/other.vue'),
  },



  { // 新闻资讯  *********************************************
    path: '/news',
    name: 'news',
    component: () => import('../views/news.vue')
  },
  { // 新闻资讯 ---- 详细新闻
    path: '/news/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/news/newsDetail.vue')
  },








  { // 联系我们 *********************************************
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact.vue')
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // console.log("xxxxxxxx")
  window.scrollTo(0, 0); // 滚动到页面的左上角

  return next();
})

export default router
